package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korge.view.*
import component.*
import network.*
import org.jbox2d.common.*

class NetworkInfoSystem(
    private val wsSessionAdapter: WsSessionAdapter,
    private val pingTextView: Text
) : IteratingSystem(family { all(PlayerComponent) }) {

    companion object {
        const val MAX_STEP_TIME = 1f
    }

    private var accumulator = 0f

    override fun onTickEntity(entity: Entity) {
        if (!wsSessionAdapter.isInit) return

        val frameTime: Float = MathUtils.min(deltaTime, 0.25f)
        accumulator += frameTime
        if (accumulator >= MAX_STEP_TIME) {
            accumulator -= MAX_STEP_TIME

            val networkComp = entity[NetworkInputDataComponent]
            pingTextView.text = "Id: ${networkComp.physicData.size}"
        }
    }
}
